// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3iX42","insightsList":"newBusinessInsightsMenu_insightsList__Bz_o2","active":"newBusinessInsightsMenu_active__f3fbr"};